import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { MemoryForm } from 'src/Components/Forms/Memory/MemoryForm';

type MemoryParams = {
  assetId: string;
  memoryId: string;
};

const EditMemoryDrawer = () => {
  const { t } = useTranslation();
  const { assetId, memoryId } = useParams<MemoryParams>();
  const timelinePath = `/asset/${assetId}/memories`;

  if (!memoryId) {
    return <Navigate to={timelinePath} replace />;
  }

  return (
    <AnimatedRoutedDrawer
      title={t('memories.form.editTitle', 'Modifier le souvenir')}
      to={`${timelinePath}/${memoryId}`}
    >
      {({ onClose }) => <MemoryForm memoryId={memoryId} onClose={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default EditMemoryDrawer;
